// Latest Observations: ws4kp fills the "Like" column only when NWS sends a wind chill or heat index for that
// station, which most stations around the Bay don't (wind chill needs 50°F or below with wind, heat index 80°F or
// above). The result was one lonely number in an empty column. Rows without one show their own temperature,
// uncoloured; a real wind chill or heat index keeps ws4kp's blue or red.
// Hourly (Oct 27, Jared: "randomly highlighted"): ws4kp colours the column whenever the forecast's apparent
// temperature differs by a degree either way, so a humid 55°F night reads red. Same rule as the observations now: blue
// only for a wind chill (50°F or below), red only for a heat index (80°F or above), else plain.

const fill = (root) => {
	root.querySelectorAll('.observation-row').forEach((row) => {
		const like = row.querySelector('.like');
		const temp = row.querySelector('.temp');
		if (like && temp && !like.textContent.trim()) like.textContent = temp.textContent;
	});
};

const deg = (el) => Number.parseInt(el?.textContent ?? '', 10);
const tidyHourly = (root) => {
	root.querySelectorAll('.hourly-row').forEach((row) => {
		const like = row.querySelector('.like');
		const temp = deg(row.querySelector('.temp'));
		if (!like || Number.isNaN(temp)) return;
		if (temp > 50) like.classList.remove('wind-chill');
		if (temp < 80) like.classList.remove('heat-index');
	});
};

const start = () => {
	const hourly = document.querySelector('#hourly-html .hourly-lines');
	if (hourly) {
		tidyHourly(hourly);
		new MutationObserver(() => tidyHourly(hourly)).observe(hourly, { childList: true, subtree: true });
	}
	const lines = document.querySelector('#latest-observations-html .observation-lines');
	if (!lines) return;
	fill(lines);
	new MutationObserver(() => fill(lines)).observe(lines, { childList: true });
};

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
else start();
